import { ImgHTMLAttributes } from 'react';
import dataForSeoFavicon from './assets/dataforseo.png';

export const DataForSeoIcon = (props: ImgHTMLAttributes<HTMLImageElement>) => (
  <img src={dataForSeoFavicon} width={12} height={12} {...props} alt="" aria-hidden="true" />
);
